import { type ActionEvent, Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

import SearchMapController from "./search_map_controller"

import * as Bloomreach from "@/helpers/bloomreach"
import { urlWithBounds } from "@/helpers/search_map"

export default class SearchFiltersController extends Controller {
  static outlets = ["search-map"]
  declare readonly searchMapOutlet: SearchMapController

  applyFilter(e: Event): void {
    e.preventDefault()

    const anchor = e.currentTarget as HTMLAnchorElement

    if (anchor.getAttribute("aria-disabled") === "true") {
      return
    }

    Bloomreach.saveSearchTermToStorage("")

    const url = urlWithBounds(anchor.href, this.searchMapOutlet.mapBounds)

    Turbo.visit(url.toString(), {
      frame: this.element.closest("turbo-frame")!.id,
      action: "advance" // This is supposed to be default but spinner doesn't work unless explicit
    })
  }

  scrollIntoView({ currentTarget }: ActionEvent): void {
    ;(currentTarget as HTMLElement).scrollIntoView({
      behavior: "instant",
      block: "nearest", // To avoid vertical scrolls
      inline: "center"
    })
  }
}
